import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";
import { batch, useDispatch } from "react-redux";
import { fetchVoucherInfo } from "redux/slices/sales/salesSlice";
import { getCommaNumber } from "utils/format";
import iconDrop from "assets/icons/icon_drop_black.svg";
import ServiceBreakdownList from "components/salesPayment/ServiceBreakdownList";
import type { BranchServiceBreakdown } from "types/ManagerPayment";

interface Props {
  branches?: BranchServiceBreakdown["branches"];
  searchPartner: number;
  searchDate: string;
}

export const BranchDetailList = ({
  branches,
  searchPartner,
  searchDate,
}: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState<number | null>(null);

  const goDetail = (seqPartnerBranch: number) => {
    batch(() => {
      dispatch(
        fetchVoucherInfo({
          searchPartner,
          searchBranch: seqPartnerBranch,
          searchDate,
        })
      );
      navigate(`/sales/voucher/${seqPartnerBranch}`);
    });
  };

  const list = branches || [];
  return (
    <Wrapper>
      {list.length === 0 && (
        <p className="empty">이 기간에 매출이 발생한 지점이 없어요</p>
      )}
      <ul className="list">
        {list.map((b) => (
          <li key={b.seqPartnerBranch}>
            <div className="head">
              <button
                className="expand"
                onClick={() =>
                  setOpen(open === b.seqPartnerBranch ? null : b.seqPartnerBranch)
                }
              >
                <span>{b.branchName}</span>
                <span className="amt">{getCommaNumber(b.totalAmount)}원</span>
              </button>
              <a className="go" onClick={() => goDetail(b.seqPartnerBranch)}>
                상세
              </a>
            </div>
            {open === b.seqPartnerBranch ? (
              <div className="body">
                <ServiceBreakdownList
                  breakdown={{
                    items: b.items,
                    penalty: { amount: 0, percentage: 0 },
                  }}
                />
              </div>
            ) : null}
          </li>
        ))}
      </ul>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .empty {
    padding: 40px 24px;
    text-align: center;
    color: var(--gray);
    font-size: var(--14px);
  }
  .list {
    padding: 0 24px;
  }
  .list > li + li {
    border-top: 1px solid var(--lightBorder);
  }
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 0;
  }
  .head .expand {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background: none;
    border: none;
    padding: 0;
    font-size: var(--16px);
  }
  .head .expand span:first-child {
    padding-right: 1em;
    background: url(${iconDrop}) no-repeat center right / 12px;
  }
  .head .expand .amt {
    font-size: var(--18px);
    font-weight: 600;
  }
  .head .go {
    margin-left: 12px;
    font-size: var(--13px);
    color: var(--gray);
  }
  .body {
    padding-bottom: 12px;
  }
`;

export default BranchDetailList;
